<template>
    <div class="userAgent-page">
        <h1 class="page-title">User Agent</h1>
            <b-col xs="12">
                <Widget
                        title="<h5>Listed <span class='fw-semi-bold'>Agents</span></h5>"
                        bodyClass="widget-table-overflow"
                        customHeader>
                    <div class="table-responsive">
                        <table class="table table-lg mb-0 requests-table">
                            <thead>
                            <tr class="text-muted">
                                <th>NAME</th>
                                <th>EMAIL</th>
                                <th>PHONE</th>
                                <th>Payment</th>
                                <th>Joining DATE</th>
                                <th>CITY</th>
                                <th>STATUS</th>
                                <th>WORK STATUS</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                    v-for="row in mock.table"
                                    :key="row.id"
                                    :class="getStyleClass(row)"
                            >
                                <td>{{row.name}}</td>
                                <td>{{row.email}}</td>
                                <td>{{row.phone}}</td>
                                <td>{{row.payment}}</td>
                                <td>{{row.date}}</td>
                                <td>{{row.city}}</td>
                                <td>
                                    <b-button @click="setSelectedAgent(row)"
                                              :variant="row.status === 'Add'? 'success' : 'danger'"
                                              class="p-1 px-3 btn-xs">
                                        {{row.status}}
                                    </b-button>
                                </td>
                                <td>{{row.workStatus}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Widget>
            </b-col>
    </div>
</template>

<script>

    import Widget from "../../../components/admin/Widget/Widget";
    import mock from "../Dashboard/mock";

    export default {
        name: 'UserAgent',
        components: {
            Widget,
        },
        data() {
            return {
                mock
            };
        },
        methods: {
            getStyleClass(a){
                if(a.workStatus===true){
                    this.class="selectedAgent";
                }else{
                    this.class="nonselectedAgent";
                }
                return this.class;
            },
            setSelectedAgent(a){
                a.workStatus=!a.workStatus;
                if(a.status==='Add') a.status='Remove';
                else a.status='Add';
            }
        },

    };
</script>

<style src="./UserAgent.scss" lang="scss" />
